/* Productos del campo: leche, queso, hortaliza y fruta. */

export function LecheGlyph() {
  return (
    <>
      <path d="M9.4 3.4h5.2" />
      <path d="M10 3.4v5.1C10 10.2 7.2 10.4 7.2 13.2v6a1.8 1.8 0 0 0 1.8 1.8h6a1.8 1.8 0 0 0 1.8-1.8v-6C16.8 10.4 14 10.2 14 8.5V3.4" />
      <path d="M7.2 15.2c1.6 1.2 3.2 1.2 4.8 0s3.2-1.2 4.8 0" />
    </>
  );
}

export function QuesoGlyph() {
  return (
    <>
      <path d="M3 18.2V11.2L21 6.4V18.2Z" />
      <circle cx="8.4" cy="14.6" r="1.4" />
      <circle cx="14.2" cy="12.6" r="1.4" />
      <path d="M17.8 15.8h.01" />
    </>
  );
}

export function HortalizaGlyph() {
  return (
    <g transform="rotate(40 12 12)">
      <path d="M12 21.8C9.6 17.4 8.4 12.8 8.7 9.9A3.3 3.3 0 0 1 15.3 9.9C15.6 12.8 14.4 17.4 12 21.8Z" />
      <path d="M10 13.6h1.8M12.3 16.8h1.6" />
      <path d="M12 6.6C11.6 5 10.6 3.9 9 3.4M12 6.6V2.4M12 6.6C12.4 5 13.4 3.9 15 3.4" />
    </g>
  );
}

export function FrutaGlyph() {
  return (
    <>
      <path d="M12 7.8C10.3 6.4 7.4 6.4 5.9 8.6C4.1 11.2 4.9 16.2 7.4 19.4C8.5 20.8 10.1 21 12 20.2C13.9 21 15.5 20.8 16.6 19.4C19.1 16.2 19.9 11.2 18.1 8.6C16.6 6.4 13.7 6.4 12 7.8Z" />
      <path d="M12 7.8C12 5.8 12.7 4.2 14 3.2" />
      <path d="M14.4 6.4C15.8 5 17.8 4.9 19 5.5C18.4 7.1 16.6 7.7 14.4 6.4Z" />
    </>
  );
}
